import { useNavigate } from 'react-router-dom';
import { FilePlus } from 'react-feather';
import TablaServidor from '../../components/tabla/TablaServidor';
import { useTituloCabecera } from '../../context/tituloCabeceraContext';
import colors from '../../theme/colors';
import { COLUMNAS_FACTURAS, TABLA_FACTURAS } from '../../components/facturas/columnasFacturas';

const ListadoFacturas = () => {
  useTituloCabecera('Facturas', 'Gestiona y busca facturas del sistema');
  const navigate = useNavigate();

  const nueva = (
    <button
      type="button"
      onClick={() => navigate('/facturas/nueva')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '7px 14px',
        fontSize: '0.8125rem',
        fontWeight: 600,
        borderRadius: 8,
        border: 0,
        cursor: 'pointer',
        background: colors.primary,
        color: '#fff',
      }}
    >
      <FilePlus size={14} />
      Nueva
    </button>
  );

  return (
    <TablaServidor
      tablaKey={TABLA_FACTURAS}
      columnas={COLUMNAS_FACTURAS}
      ruta="listado-facturas"
      archivo="facturas"
      nombreEntidad="facturas"
      placeholder="Buscar por nº de factura, cliente, alumno o CIF/NIF…"
      barraExtra={nueva}
      claveFila={(f) => `${f.empresaId}-${f.factura}`}
      onFilaClick={(f) => navigate(`/facturas/${f.empresaId}/${f.factura}/detalles/`)}
      tituloTarjeta={(f) => `#${f.factura} · ${f.cliente || f.alumno || ''}`.trim()}
    />
  );
};

export default ListadoFacturas;
